import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './Exercies.css';
import Logo from './assets/Logo.png';
import { db } from '../Firebase';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import Swal from 'sweetalert2';
import SlotGameModal from '../game2/SlotGame';
import ImageExplosion from '../TextExplosion/ImageExplosion';
import SpacialExecries from '../SpacialExecries/SpacialExecries';
import SolveGame from '../game3/solvegame';
import MatchGame from '../game1/matchgame';

const importAll = (r) => {
  let images = {};
  r.keys().map((item, index) => { 
    images[item.replace('./Level-', '').replace('.gif', '')] = r(item); 
    return item;
  });
  return images;
}

const levelImages = importAll(require.context('./assets', false, /Level-\d+\.gif$/));

function Exercies({ userData, onLogout, onUserUpdate }) { 
  const navigate = useNavigate();
  const totalScore = userData?.score !== undefined ? `${userData.score} Points` : '... Points';
  const [isCheckingBonus, setIsCheckingBonus] = useState(false);
  const [bonusStatus, setBonusStatus] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [showSlotGame, setShowSlotGame] = useState(false);
  const [slotGameShown, setSlotGameShown] = useState(false); // เพิ่ม state เพื่อป้องกันการแสดงซ้ำ
  const [showExplosion, setShowExplosion] = useState(false);
  const [showSpacialModal, setShowSpacialModal] = useState(false);
  const [spacialModalShown, setSpacialModalShown] = useState(false); // เพิ่ม state เพื่อป้องกันการแสดงซ้ำ
  const [showSolveGame, setShowSolveGame] = useState(false);
  const [currentState, setCurrentState] = useState(1); // เพิ่ม state สำหรับ current state จาก database
  const [silverValue, setSilverValue] = useState(0); // เพิ่ม state สำหรับ silver จาก database
  const [goldValue, setGoldValue] = useState(0); // เพิ่ม state สำหรับ gold จาก database
  const [diamondValue, setDiamondValue] = useState(0); // เพิ่ม state สำหรับ diamond จาก database
  const [levelMeter, setLevelMeter] = useState(0); // เพิ่ม state สำหรับ Level-Meter จาก database
  const [bonusSpacial, setBonusSpacial] = useState(0); // เพิ่ม state สำหรับ Bonus-Spacial จาก database
  const [bonusSolve, setBonusSolve] = useState(0); // เพิ่ม state สำหรับ Bonus-Solve จาก database
  const [bonusMatch, setBonusMatch] = useState(0); // เพิ่ม state สำหรับ Bonus-Match จาก database
  const [showMatchGame, setShowMatchGame] = useState(false); // เพิ่ม state สำหรับแสดง MatchGame
  const [isDataLoaded, setIsDataLoaded] = useState(false); // เพิ่ม state สำหรับตรวจสอบว่าโหลดข้อมูลแล้วหรือยัง
  const [isReturningFromGame, setIsReturningFromGame] = useState(false); // เพิ่ม state สำหรับตรวจสอบว่ากำลังกลับมาจากเกมหรือไม่

  // ปิด MatchGame ทันทีเมื่อ component mount
  useEffect(() => {
    setShowMatchGame(false);
  }, []);

  // คำนวณ currentLevel จากผลรวมของ show-silver + show-gold + show-diamond โดยใช้ useMemo
  const currentLevel = useMemo(() => {
    // ตรวจสอบว่า state ถูกกำหนดค่าแล้วหรือยัง และข้อมูลโหลดเสร็จแล้ว
    if (isDataLoaded && typeof silverValue === 'number' && typeof goldValue === 'number' && typeof diamondValue === 'number') {
      const result = silverValue + goldValue + diamondValue;
      return result;
    }
    return 0; // ค่าเริ่มต้น
  }, [silverValue, goldValue, diamondValue, isDataLoaded]);
  
  // ตรวจสอบว่า currentLevel เป็นตัวเลขที่ถูกต้อง
  const safeCurrentLevel = useMemo(() => {
    return isNaN(currentLevel) || currentLevel < 0 ? 0 : currentLevel;
  }, [currentLevel]);

  // ปิด MatchGame ทันทีเมื่อ currentLevel เปลี่ยน
  useEffect(() => {
    if (safeCurrentLevel > 0) {
      const isMatchGameLevel = matchGameLevels.includes(safeCurrentLevel);
      
      if (!isMatchGameLevel) {
        setShowMatchGame(false);
      }
    }
  }, [safeCurrentLevel]);

  // ตรวจสอบว่าผลบวกตรงกับค่าที่กำหนดให้ run SpacialExecries
  const specialLevels = [7, 13, 19, 25, 31, 37, 43, 49, 57, 65, 72, 80, 87, 95, 102, 110, 117, 125, 132, 140, 147, 155, 162, 170, 177, 185, 192, 199];
  
  // ตรวจสอบว่าผลบวกตรงกับค่าที่กำหนดให้ run SolveGame
  const solveGameLevels = [6, 16, 26, 35, 45, 52, 60, 70, 78, 88, 98, 108, 118, 128, 138, 148, 158, 168, 178, 188, 198];
  
  // ตรวจสอบว่าผลบวกตรงกับค่าที่กำหนดให้ run MatchGame
  const matchGameLevels = [9, 23, 41, 58, 76, 91, 106, 121, 142, 160, 180, 196];
  
  const shouldShowSpacialExecries = useMemo(() => {
    const isSpecialLevel = specialLevels.includes(safeCurrentLevel);
    const bonusSpacialNotEqual = bonusSpacial !== safeCurrentLevel;
    const result = isDataLoaded && isSpecialLevel && bonusSpacialNotEqual;
    
    return result;
  }, [isDataLoaded, safeCurrentLevel, bonusSpacial]);

  const shouldShowSolveGame = useMemo(() => {
    const isSolveGameLevel = solveGameLevels.includes(safeCurrentLevel);
    const bonusSolveNotEqual = bonusSolve !== safeCurrentLevel;
    const result = isDataLoaded && isSolveGameLevel && bonusSolveNotEqual;
    
    return result;
  }, [isDataLoaded, safeCurrentLevel, bonusSolve]);

  const shouldShowMatchGame = useMemo(() => {
    const isMatchGameLevel = matchGameLevels.includes(safeCurrentLevel);
    const bonusMatchNotEqual = bonusMatch !== safeCurrentLevel;
    const result = isDataLoaded && isMatchGameLevel && bonusMatchNotEqual && !isReturningFromGame;
    
    return result;
  }, [isDataLoaded, safeCurrentLevel, bonusMatch, isReturningFromGame]);
  
  const imageToDisplay = useMemo(() => {
    return levelImages[safeCurrentLevel] || levelImages['0'];
  }, [safeCurrentLevel]);
  
  const isMaxLevelReached = useMemo(() => {
    return safeCurrentLevel > 199;
  }, [safeCurrentLevel]);



  const checkBonusStatus = useCallback(async () => {
    if (!userData?.username) return false;
    
    setIsCheckingBonus(true);
    try {
      // ใช้ document ID เดียวกับที่ Login ใช้ (ไม่แปลงเป็นตัวเล็ก)
      const userRef = doc(db, "Competition-Training", userData.username);
      const docSnap = await getDoc(userRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        const bonus = data.bonus;
        const dbCurrentState = data['current-state'] || 1; // อ่าน current-state จาก database
        const dbSilverValue = data['show-silver'] || 0; // อ่าน show-silver จาก database
        const dbGoldValue = data['show-gold'] || 0; // อ่าน show-gold จาก database
        const dbDiamondValue = data['show-diamond'] || 0; // อ่าน show-diamond จาก database
        const dbLevelMeter = data['Level-Meter'] || 0; // อ่าน Level-Meter จาก database
        const dbBonusSpacial = data['Bonus-Spacial'] || 0; // อ่าน Bonus-Spacial จาก database
        const dbBonusSolve = data['Bonus-Solve'] || 0; // อ่าน Bonus-Solve จาก database
        const dbBonusMatch = data['Bonus-Match'] || 0; // อ่าน Bonus-Match จาก database
        

        setBonusStatus(bonus);
        setCurrentState(dbCurrentState); // เก็บค่า current state
        setSilverValue(dbSilverValue); // เก็บค่า silver
        setGoldValue(dbGoldValue); // เก็บค่า gold
        setDiamondValue(dbDiamondValue); // เก็บค่า diamond
        setLevelMeter(dbLevelMeter); // เก็บค่า Level-Meter
        setBonusSpacial(dbBonusSpacial); // เก็บค่า Bonus-Spacial
        setBonusSolve(dbBonusSolve); // เก็บค่า Bonus-Solve
        setBonusMatch(dbBonusMatch); // เก็บค่า Bonus-Match
        setIsDataLoaded(true); // ตั้งค่าว่าโหลดข้อมูลแล้ว

        // คำนวณ currentLevel จากข้อมูลที่อ่านจาก database
        const calculatedLevel = dbSilverValue + dbGoldValue + dbDiamondValue;
        
        // ตรวจสอบและปิด MatchGame ถ้าไม่ควรแสดง
        const isMatchGameLevel = matchGameLevels.includes(calculatedLevel);
        const bonusMatchNotEqual = dbBonusMatch !== calculatedLevel;
        if (isMatchGameLevel && !bonusMatchNotEqual) {
          setShowMatchGame(false);
        }
        
        if (bonus && calculatedLevel < 119) {
          Swal.fire({
            title: "โบนัส!",
            text: "คุณจะได้รับโบนัสเมื่อเริ่มทำแบบฝึกหัดต่อไป",
            icon: "success",
            confirmButtonText: "รับทราบ"
          });
        }
      } else {
        console.warn("User data not found for bonus check.");
        setBonusStatus(false);
        setCurrentState(1); // ค่าเริ่มต้น
        setSilverValue(0); // ค่าเริ่มต้น
        setGoldValue(0); // ค่าเริ่มต้น
        setDiamondValue(0); // ค่าเริ่มต้น
        setLevelMeter(1); // ค่าเริ่มต้น
        setBonusSpacial(0); // ค่าเริ่มต้น
        setBonusSolve(0); // ค่าเริ่มต้น
        setBonusMatch(0); // ค่าเริ่มต้น
        setIsDataLoaded(true); // ตั้งค่าว่าโหลดข้อมูลแล้ว
        // ปิด MatchGame เมื่อไม่มีข้อมูลผู้ใช้
        setShowMatchGame(false);
      }
    } catch (error) {
      console.error("Error checking bonus status:", error);
      setBonusStatus(false);
      setCurrentState(1); // ค่าเริ่มต้น
      setSilverValue(0); // ค่าเริ่มต้น
      setGoldValue(0); // ค่าเริ่มต้น
      setDiamondValue(0); // ค่าเริ่มต้น
      setLevelMeter(1); // ค่าเริ่มต้น
      setBonusSpacial(0); // ค่าเริ่มต้น
      setBonusSolve(0); // ค่าเริ่มต้น
      setBonusMatch(0); // ค่าเริ่มต้น
      setIsDataLoaded(true); // ตั้งค่าว่าโหลดข้อมูลแล้ว
      // ปิด MatchGame เมื่อเกิดข้อผิดพลาด
      setShowMatchGame(false);
    } finally {
      setIsCheckingBonus(false);
    }
  }, [userData]);

  // ฟังก์ชันจัดการการกดปุ่มที่ logo
  const handleLogoClick = useCallback(() => {
    setShowSolveGame(true);
  }, []);

  useEffect(() => {
    checkBonusStatus();
    // ปิด MatchGame เมื่อ component โหลดครั้งแรก
    setShowMatchGame(false);
  }, [checkBonusStatus]);

  // เพิ่ม useEffect สำหรับรีเฟรชข้อมูลเมื่อ userData เปลี่ยน
  useEffect(() => {
    if (userData?.username) {
      checkBonusStatus();
      // ไม่ต้องเรียก updateLevelId ซ้ำ เพราะ checkBonusStatus จะเรียกแล้ว
    }
  }, [userData, checkBonusStatus]);

  // แสดง ImageExplosion อัตโนมัติหลังเข้าหน้่า Exercies
  useEffect(() => {
    const timerId = setTimeout(() => {
      setShowExplosion(true);
    }, 1000);
    return () => clearTimeout(timerId);
  }, []);

  // ฟัง custom event จาก VideoDisp เพื่อแสดง SlotGameModal
  useEffect(() => {
    const handleTriggerSlotGame = (event) => {
      setShowSlotGame(true);
    };

    // ตรวจสอบ localStorage
    const checkLocalStorage = () => {
      const triggerValue = localStorage.getItem('triggerSlotGame');
      if (triggerValue === 'true') {
        setShowSlotGame(true);
        localStorage.removeItem('triggerSlotGame'); // ลบหลังจากใช้แล้ว
      }
    };

    window.addEventListener('triggerSlotGame', handleTriggerSlotGame);
    
    // ตรวจสอบ localStorage ทันที
    checkLocalStorage();
    
    // ตรวจสอบ localStorage ทุก 1000ms (ลดความถี่เพื่อปรับปรุงประสิทธิภาพ)
    const interval = setInterval(checkLocalStorage, 1000); // เพิ่มเวลาระหว่างการตรวจสอบจาก 100ms เป็น 1000ms
    
    return () => {
      window.removeEventListener('triggerSlotGame', handleTriggerSlotGame);
      clearInterval(interval);
    };
  }, []); // ใช้ empty dependency array เพื่อให้ event listener ถูกเพิ่มเพียงครั้งเดียว


  // ตรวจสอบและแสดง SpacialExecries เมื่อผลบวกตรงกับค่าที่กำหนด
  useEffect(() => {
    
    if (shouldShowSpacialExecries && !spacialModalShown) {
      setSpacialModalShown(true); // ตั้งค่าว่าแสดงแล้ว
      setShowSpacialModal(true);
    }
  }, [shouldShowSpacialExecries, safeCurrentLevel, spacialModalShown, bonusSpacial]);

  // ตรวจสอบและแสดง SolveGame เมื่อผลบวกตรงกับค่าที่กำหนด
  useEffect(() => {
    if (shouldShowSolveGame) {
      setShowSolveGame(true);
    }
  }, [shouldShowSolveGame, safeCurrentLevel, bonusSolve]);

  // ตรวจสอบและแสดง MatchGame เมื่อผลบวกตรงกับค่าที่กำหนด
  useEffect(() => {
    
    if (shouldShowMatchGame) {
      setShowMatchGame(true);
    } else {
      // ถ้าไม่ควรแสดง MatchGame ให้ปิด modal
      if (showMatchGame) {
        setShowMatchGame(false);
      }
    }
  }, [shouldShowMatchGame, safeCurrentLevel, bonusMatch, showMatchGame, isReturningFromGame]);

  // ปิด MatchGame เมื่อข้อมูลโหลดเสร็จและตรวจสอบเงื่อนไขแล้ว
  useEffect(() => {
    if (isDataLoaded && safeCurrentLevel > 0) {
      const isMatchGameLevel = matchGameLevels.includes(safeCurrentLevel);
      const bonusMatchNotEqual = bonusMatch !== safeCurrentLevel;
      
      
      // ปิด MatchGame ถ้าไม่ใช่ level ที่กำหนด หรือ bonusMatch เท่ากับ currentLevel หรือกำลังกลับมาจากเกม
      if (!isMatchGameLevel || (isMatchGameLevel && !bonusMatchNotEqual) || isReturningFromGame) {
        setShowMatchGame(false);
      }
    }
  }, [isDataLoaded, safeCurrentLevel, bonusMatch, isReturningFromGame]);


  // (ข้อกำหนดใหม่) ไม่เล่นเสียงหลักเมื่อเข้าหน้า Exercies

  // ฟังก์ชันสำหรับรีเซ็ตข้อมูลเมื่อครบ 200 ข้อ
  const handleResetData = async () => {
    if (!userData?.username) {
      Swal.fire('เกิดข้อผิดพลาด', 'ไม่พบข้อมูลผู้ใช้', 'error');
      return;
    }

    try {
      const userRef = doc(db, "Competition-Training", userData.username);
      
      // 1. อ่านข้อมูลปัจจุบันก่อนรีเซ็ต
      const docSnap = await getDoc(userRef);
      if (!docSnap.exists()) {
        Swal.fire('เกิดข้อผิดพลาด', 'ไม่พบข้อมูลผู้ใช้ในฐานข้อมูล', 'error');
        return;
      }
      
      const currentData = docSnap.data();
      const totalLevel = (currentData['show-silver'] || 0) + (currentData['show-gold'] || 0) + (currentData['show-diamond'] || 0);
      
      // 2. แสดง confirmation dialog
      const result = await Swal.fire({
        title: '⚠️ ยืนยันการรีเซ็ตข้อมูล',
        html: `
          <div style="text-align: center; margin: 5px 0;">
            <p><strong>คุณกำลังจะรีเซ็ตข้อมูลทั้งหมด!</strong></p>

            <div style="text-align: left; margin: 20px 0;">
              <p><strong>ข้อมูลปัจจุบัน:</strong></p>
              <ul style="margin: 10px 0; padding-left: 20px;">
                <li>🥈 Silver: ${currentData['show-silver'] || 0} ครั้ง</li>
                <li>🥇 Gold: ${currentData['show-gold'] || 0} ครั้ง</li>
                <li>💎 Diamond: ${currentData['show-diamond'] || 0} ครั้ง</li>
                <li>🏆 คุณได้รับคะแนนรวม: ${currentData.score || 0} คะแนน</li>
              </ul>
            </div>

            </ul>
            <br>
            <p style="color: #e74c3c;"><strong>⚠️เมื่อคุณกดปุ่มรีเซ็ตคะแนนทั้งหมดจะเป็นศูนย์ เมื่อรีเซ็ตแล้วไม่สามารถย้อนกลับได้!</strong></p>
            <p>คะแนนจะถูกบันทึกในประวัติก่อนรีเซ็ต</p>
          </div>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยันรีเซ็ต',
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#e74c3c',
        cancelButtonColor: '#6c757d',
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: '500px'
      });
      
      // 3. ตรวจสอบว่าผู้ใช้ยืนยันหรือไม่
      if (!result.isConfirmed) {
        return;
      }
      
      // 4. แสดง loading dialog
      Swal.fire({
        title: 'กำลังรีเซ็ตข้อมูล...',
        text: 'กรุณารอสักครู่',
        icon: 'info',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      // 5. เตรียมข้อมูลที่จะบันทึกใน History
      const historyData = {
        name: currentData.name || '',
        surname: currentData.surname || '',
        showSilver: currentData['show-silver'] || 0,
        showGold: currentData['show-gold'] || 0,
        showDiamond: currentData['show-diamond'] || 0,
        score: currentData.score || 0,
        resetDate: new Date().toISOString(),
        totalLevel: totalLevel
      };
      
      
      // 6. บันทึกข้อมูลใน Collection History
      const historyRef = doc(db, "Competition-Training", userData.username, "History", `reset_${Date.now()}`);
      await setDoc(historyRef, historyData);
      
      
      // 7. กำหนดค่า current-state ตามเงื่อนไขก่อนรีเซ็ต
      let newCurrentState = 1; // ค่าเริ่มต้น
      
      if (currentData['show-diamond'] >= 25) {
        newCurrentState = 3;
      } else if (currentData['show-diamond'] < 25 && currentData['show-gold'] >= 25) {
        newCurrentState = 2;
      } else if (currentData['show-diamond'] < 25 && currentData['show-gold'] < 25) {
        newCurrentState = 1;
      }
      
      
      // 8. อัปเดตข้อมูลทั้งหมดตามที่กำหนด (ยกเว้น current-state)
      await updateDoc(userRef, {
        'Bonus-Match': 0,
        'Bonus-Slot': 0,
        'Bonus-Solve': 0,
        'Bonus-Spacial': 0,
        'Diamond-Max': 0,
        'Gold-Max': 0,
        'Silver-Max': 0,
        'Level-ID': 0,
        'Level-Meter': 1,
        'SolveLevel': 0,
        'Spacial-Level': 0,
        'Time-Accu': 0,
        'score': 0,
        'show-diamond': 0,
        'show-gold': 0,
        'show-silver': 0,
        'State-Show': false,
        'Diamond-Remain': [],
        'Gold-Remain': [],
        'Silver-Remain': [],
        'Level-Temp': []
      });

      // 9. อัปเดต current-state ตามเงื่อนไขที่กำหนด
      await updateDoc(userRef, {
        'current-state': newCurrentState
      });

      
      // 10. แสดงข้อความสำเร็จ
      Swal.fire({
        title: "🎉 รีเซ็ตสำเร็จ!",
        html: `
          <div style="text-align: left; margin: 20px 0;">
            <p><strong>ข้อมูลถูกรีเซ็ตเรียบร้อยแล้ว</strong></p>
            <br>
            <p><strong>ข้อมูลที่บันทึกในประวัติ:</strong></p>
            <ul style="margin: 10px 0; padding-left: 20px;">
              <li>📊 ระดับรวม: ${historyData.totalLevel}</li>
              <li>🏆 คะแนน: ${historyData.score}</li>
              <li>📅 วันที่รีเซ็ต: ${new Date(historyData.resetDate).toLocaleDateString('th-TH')}</li>
            </ul>
            <br>
            <p style="color: #27ae60;"><strong>✅ เกมจะเริ่มใหม่จากระดับ ${newCurrentState === 3 ? 'Diamond' : newCurrentState === 2 ? 'Gold' : 'Silver'}</strong></p>
          </div>
        `,
        icon: "success",
        confirmButtonText: "ตกลง",
        width: '500px'
      }).then(() => {
        // รีเฟรชหน้า Exercies
        window.location.reload();
      });
      
    } catch (error) {
      console.error("Error resetting data:", error);
      Swal.fire('เกิดข้อผิดพลาด', 'ไม่สามารถรีเซ็ตข้อมูลได้', 'error');
    }
  };

  const handleStartExercise = () => {
    if (isMaxLevelReached) {
      handleResetData();
      return;
    }
    if (bonusStatus) {
        navigate('/match-game');
    } else {
        navigate('/video');
    }
  };

  const handleGoToLeaderboard = () => {
    navigate('/leaderboard');
  };

  const handleGoToSpacialExecries = () => {
    setShowSpacialModal(true);
  };

  const handleOpenSolveGame = () => {
    setShowSolveGame(true);
  };

  // ฟังก์ชันสำหรับจัดการการซูม
  const handleZoom = (direction) => {
    if (direction === 'in') {
      setZoomLevel(prev => Math.min(prev + 0.2, 3));
    } else if (direction === 'out') {
      setZoomLevel(prev => Math.max(prev - 0.2, 0.5));
    } else {
      setZoomLevel(1);
      setImagePosition({ x: 0, y: 0 });
    }
  };

  // ฟังก์ชันสำหรับจัดการการลากภาพ
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStart({
      x: e.clientX - imagePosition.x,
      y: e.clientY - imagePosition.y
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    const newX = e.clientX - dragStart.x;
    const newY = e.clientY - dragStart.y;
    
    // จำกัดขอบเขตการลาก
    const maxMove = 200;
    setImagePosition({
      x: Math.max(Math.min(newX, maxMove), -maxMove),
      y: Math.max(Math.min(newY, maxMove), -maxMove)
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // สำหรับอุปกรณ์ touch
  const handleTouchStart = (e) => {
    if (e.touches.length === 1) {
      setIsDragging(true);
      setDragStart({
        x: e.touches[0].clientX - imagePosition.x,
        y: e.touches[0].clientY - imagePosition.y
      });
    }
  };

  const handleTouchMove = (e) => {
    if (!isDragging || e.touches.length !== 1) return;
    
    const newX = e.touches[0].clientX - dragStart.x;
    const newY = e.touches[0].clientY - dragStart.y;
    
    // จำกัดขอบเขตการลาก
    const maxMove = 200;
    setImagePosition({
      x: Math.max(Math.min(newX, maxMove), -maxMove),
      y: Math.max(Math.min(newY, maxMove), -maxMove)
    });
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  // แสดง loading หากข้อมูลยังไม่โหลดเสร็จ
  if (!isDataLoaded) {
    return (
      <div className="exercies-container">
        <div className="loading-container">
          <h2>กำลังโหลดข้อมูล...</h2>
        </div>
      </div>
    );
  }

  // ปิด MatchGame ถ้าไม่ควรแสดง
  if (isDataLoaded && safeCurrentLevel > 0) {
    const isMatchGameLevel = matchGameLevels.includes(safeCurrentLevel);
    const bonusMatchNotEqual = bonusMatch !== safeCurrentLevel;
    
    
    // ปิด MatchGame ถ้าไม่ใช่ level ที่กำหนด หรือ bonusMatch เท่ากับ currentLevel หรือกำลังกลับมาจากเกม
    if ((!isMatchGameLevel || (isMatchGameLevel && !bonusMatchNotEqual) || isReturningFromGame) && showMatchGame) {
      setShowMatchGame(false);
    }
  }

  return (
    <div className="exercies-container">
      <div 
        className="image-section"
      >
        {/* Level Meter Bar */}
        <div className="level-meter-container">
          <div className="level-meter-title">Level Meter</div>
          <div className="level-meter-bar">
            {[1, 2, 3, 4, 5].map((slot) => (
              <div 
                key={slot} 
                className={`level-meter-slot ${levelMeter >= slot ? 'filled' : 'empty'}`}
              >
                {levelMeter >= slot ? '⭐' : '☆'}
              </div>
            ))}
          </div>
          {/* <div className="current-level-display">
            <strong>Current Level: {safeCurrentLevel}</strong>
          </div> */}
        </div>

        {imageToDisplay ? (
          <img 
            src={imageToDisplay} 
            alt={`Level ${safeCurrentLevel} (Silver: ${silverValue}, Gold: ${goldValue}, Diamond: ${diamondValue})`} 
            className="full-image"
            style={{
              transform: 'none',
              cursor: 'default'
            }}
          />
        ) : (
          <div className="no-image">No image for this level.</div>
        )}
        
        {/* ปุ่มควบคุมการซูม ถูกนำออกตามคำขอ */}
      </div>
      
      <div className="input-section">
        <div className="logo-container">
          <img 
            src={Logo} 
            alt="Logo" 
            className="logo-image2" 
         //  onClick={handleLogoClick} //
         //   style={{ cursor: 'pointer' }} //
          />
        </div>
        <h2 className="section-title">แบบฝึกพัฒนาสมอง</h2>
        <h2 className="section-title">สร้างสมาธิ</h2>

        <div className="input-group level-display-group">
          <div className={`display-level ${
            currentState === 3 ? 'diamond-state' : 
            currentState === 2 ? 'gold-state' : 
            'silver-state'
            }`}>
            <div className="current-state-title">{currentState === 3 ? '💎 Diamond' : currentState === 2 ? '🥇 Gold' : '🥈 Silver'}</div>
            <div className="state-values">
              <div>🥈 {silverValue}</div>
              <div>🥇 {goldValue}</div>
              <div>💎 {diamondValue}</div>
            </div>
          </div>
{/*          <div className="level-calculation-info">
            <small>Level = {silverValue} + {goldValue} + {diamondValue} = {safeCurrentLevel}</small>
          </div> */}
        </div>

        <div> <h3> </h3></div>

        <div className="input-group score-display-group">
          <label className="input-label">Total Score</label>
          <div className="display-score">{totalScore}</div>
        </div>

{/*        <div className="input-group level-display-group">
          <label className="input-label">Current Level</label>
          <div className="display-level-value">{safeCurrentLevel}</div>
        </div> */}

        <button
          onClick={handleStartExercise}
          className="solid-button"
          disabled={isCheckingBonus}
        >
          {isCheckingBonus ? 'กำลังตรวจสอบ...' : 
           isMaxLevelReached ? 'Reset' : 'เริ่มเลย!'}
        </button>
        
        {isMaxLevelReached && (
          <div className="completion-message">
            กดปุ่ม Reset เพื่อทำแบบฝึกหัดใหม่
          </div>
        )}

        <button
          onClick={handleGoToLeaderboard}
          className="solid-button leaderboard-button"
          style={{ marginTop: '15px' }}
        >
          Leaderboard
        </button>

        {onLogout && (
          <button
            onClick={onLogout}
            className="solid-button"
            style={{ marginTop: '15px', backgroundColor: '#dc3545' }}
          >
            ออกจากระบบ
          </button>
        )}
        <p></p>
        <p>Logged in as: {userData.username}</p>
      </div>
      {showExplosion && (
        <ImageExplosion onAnimationEnd={() => setShowExplosion(false)} />
      )}
      {showSlotGame && (
        <>
          <SlotGameModal 
            userData={userData} 
            onUserUpdate={onUserUpdate}
          onOpen={() => {
            setSlotGameShown(true); // ตั้งค่า slotGameShown เมื่อเปิด
          }}
          onClose={() => {
            setShowSlotGame(false);
            setSlotGameShown(false); // รีเซ็ต slotGameShown เมื่อปิด
            
            // ไม่ต้อง refresh หน้าเว็บ เพราะจะทำให้ไปที่หน้า login
            // window.location.reload();
          }}
        />
        </>
      )}
      <SpacialExecries
        userData={userData}
        onUserUpdate={onUserUpdate}
        visible={showSpacialModal}
        onClose={() => {
          setShowSpacialModal(false);
          setSpacialModalShown(false); // รีเซ็ต spacialModalShown เมื่อปิด
          // อัปเดต bonusSpacial เป็น currentLevel เพื่อป้องกันการแสดง modal ซ้ำ
          setBonusSpacial(safeCurrentLevel);
        }}
      />
      <SolveGame
        userData={userData}
        onUserUpdate={onUserUpdate}
        visible={showSolveGame}
        onClose={() => {
          setShowSolveGame(false);
          // อัปเดต bonusSolve เป็น currentLevel เพื่อป้องกันการแสดง modal ซ้ำ
          setBonusSolve(safeCurrentLevel);
        }}
      />
      <MatchGame
        userData={userData}
        onUserUpdate={onUserUpdate}
        visible={showMatchGame}
        onClose={() => {
          setShowMatchGame(false);
          setIsReturningFromGame(true); // ตั้งค่าว่ากำลังกลับมาจากเกม
          // ใช้ onUserUpdate เพื่อรีเฟรชข้อมูลจาก database
          if (onUserUpdate && userData?.username) {
            onUserUpdate(userData.username);
          }
          
          // รีเซ็ต isReturningFromGame หลังจาก 2 วินาที
          setTimeout(() => {
            setIsReturningFromGame(false);
          }, 2000);
          
          // ไม่ต้อง refresh หน้าเว็บ
          // window.location.reload();
        }}
      />
    </div>
  );
}

export default Exercies;